<div class="automation-rules" *ngIf="this.ruleDetails != null">

  <sc-master-detail [selection]="[selectedRule]" [data]="rules" (selectionChanged)="onSelectionChanged($event);"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);" [newStyle]="true">

    <div class="automation-rule-details">
      <div class="form-box" [formGroup]="detailsForm">

        <sc-flex [vertical]="true" [stretchContent]="true">

          <mat-form-field>
            <input matInput appPositiveInteger type="number" min="0" name="index" formControlName="index"
              placeholder="{{'index' | translate:['tmc-yard.widgets.automation-rules.index', translationService.language]}}"
              [required]="true" [maxLength]="255">
          </mat-form-field>


          <mat-form-field>
            <input matInput name="name" formControlName="name"
              placeholder="{{'name' | translate:['tmc-yard.widgets.automation-rules.name', translationService.language]}}"
              [required]="true" [maxLength]="255">
          </mat-form-field>

          <mat-form-field>
            <mat-select name="type" formControlName="type" required
              placeholder="{{'automation type' | translate: ['tmc-yard.widgets.automation-rules.automation-type', translationService.language]}}">
              <mat-option *ngFor="let typeOption of automationRuleTypeOptions" [value]="typeOption">
                {{typeOption | translate:
                ['tmc-yard.widgets.automation-rules.automation-type.'+typeOption,
                translationService.language]}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-checkbox *ngIf="this.ruleDetails.type === automationRuleType.ASSIGNMENT" formControlName="onlyPlanned"
            name="onlyPlanned">
            {{'onlyPlanned' | translate:
            ['tmc-yard.widgets.automation-rules.only-planned',
            translationService.language]}}
          </mat-checkbox>

          <ng-container
            *ngIf="!(this.ruleDetails.type === automationRuleType.ASSIGNMENT &&  this.ruleDetails.onlyPlanned)">
            <mat-form-field>
              <input matInput name="numberPlate" formControlName="numberPlate"
                placeholder="{{'number plate' | translate:['tmc-yard.widgets.automation-rules.number-plate', translationService.language]}}"
                [required]="false" [maxLength]="255">
            </mat-form-field>

            <mat-form-field>
              <input matInput name="carrier" formControlName="carrier"
                placeholder="{{'carrier' | translate:['tmc-yard.widgets.automation-rules.carrier', translationService.language]}}"
                [required]="false" [maxLength]="255">
            </mat-form-field>

            <mat-form-field>
              <input matInput name="orderReference" formControlName="orderReference"
                placeholder="{{'orderReference' | translate:['tmc-yard.widgets.automation-rules.order-reference', translationService.language]}}"
                [required]="false" [maxLength]="255">
            </mat-form-field>
          </ng-container>


          <h3>
            {{'assigned stations' | translate:['tmc-yard.widgets.automation-rules.assigned-stations.title',
            translationService.language]}}
          </h3>
          <div class="rule-station-assignment">
            <div class="rule-stations-list" style="grid-column: 1; grid-row:  2;" cdkDropList
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropAssignmentRuleStation($event)">
              <div class="rule-station" *ngFor="let station of getStationsOfRule()" cdkDrag>
                {{station.name}}
                <i (click)="removeStationFromStationAssignmentRule(station)"
                  class="cursor-pointer fa-light fa-times"></i>
              </div>
            </div>
            <div class="delete-button-wrapper" style="grid-column: 2; grid-row:  2;">
              <i class="cursor-pointer fa-light fa-plus" (click)="addStationToStationAssignmentRule()"></i>
            </div>
          </div>
          <div class="configChangedText" *ngIf="showStationsError">
            <div class="validation-error">
              {{'Save not possible! Rules must have at least one assigned Starion' | translate:
              ['tmc-yard.widgets.automation-rules.validation-error.rules.invalid-station',
              translationService.language]}}
            </div>
          </div>

        </sc-flex>

      </div>

    </div>

    <ng-template masterDetailToolbar>

      <button mat-stroked-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled">{{'cancel'
        |
        translate: ['tmc-yard.action.cancel', translationService.language]}}</button>
      <div class="spacer"></div>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
        translate: ['tmc-yard.action.save', translationService.language]}}</button>
    </ng-template>

  </sc-master-detail>


</div>
